import { TipoReceita } from "../../../../consulta/distribuicao-mensal-aos-municipio/shared/model/distribuicaoMensalMunicipio.model";
import { MensagemErroModel } from "../../../../shared/model/mensagem-erro.model";

export class InputDadosModelView{

  TipoReceitaSelected: TipoReceita;
  ObjetoMensagem: MensagemErroModel;
  ArquivoImpm : any
}

export class OutputDadosModelView{

  ListaTipoReceita: TipoReceita[];
  ObjetoMensagem: MensagemErroModel;
}



// WEBPACK FOOTER //
// ./src/app/ipm/transmissao-arquivo-ipm/shared/model/transmissao-arquivo-ipm.model.ts